import InboxV2 from "./inbox-v2-mapping";

export default InboxV2;
